import { AppState } from './app-state';
import { Action, createReducer, on } from '@ngrx/store';
import { AppActions } from './app-actions';


const initialAppState: AppState = {
  commonData: null,
  contractData: null,
  conditions: null,
};

const appReducer = createReducer(
  initialAppState,
  on(AppActions.setCommonData, (state, {commonData}) => ({...state, commonData})),
  on(AppActions.setContractData, (state, {contractData}) => ({...state, contractData})),
  on(AppActions.reset, state => ({...initialAppState})),
  on(AppActions.setConditions, (state, {conditions}) => ({...state, conditions})),
  on(AppActions.logout, state => ({
    ...state,
    contractData: null,
    commonData: {
      ...state.commonData,
      authorized: false,
      user: null,
      news_data: null
    }
  })),
);

export function reducer(state: AppState | undefined, action: Action): AppState {
  return appReducer(state, action);
}
